import { render, staticRenderFns } from "./BlackBox.vue?vue&type=template&id=5a27f142&scoped=true"
import script from "./BlackBox.vue?vue&type=script&lang=js"
export * from "./BlackBox.vue?vue&type=script&lang=js"
import style0 from "./BlackBox.vue?vue&type=style&index=0&id=5a27f142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27f142",
  null
  
)

export default component.exports